/* tslint:disable */
/* eslint-disable */
/* @relayHash afc0ddcb3e36a5626e700de6f86761b3 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type headerRootQueryVariables = {
    hasUserId: boolean;
    hasTradeUserId: boolean;
    previewKey?: string | null;
    userId: string;
    userIds: Array<string | null>;
    isClient: boolean;
    fetchRegionalInfo: boolean;
    fetchTradeNav: boolean;
    fetchNav: boolean;
    zipCode: string;
    userCountryCode?: string | null;
    hasSessionCountryCode: boolean;
    localRecentHistoryItemIds?: Array<string | null> | null;
    fetchUserRecentHistoryItem?: boolean | null;
    checkoutUserId: string;
    hasCheckoutUserId: boolean;
};
export type headerRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"Header_viewer">;
    };
};
export type headerRootQuery = {
    readonly response: headerRootQueryResponse;
    readonly variables: headerRootQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasTradeUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "previewKey",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isClient",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchRegionalInfo",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchTradeNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "fetchNav",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "zipCode",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "hasSessionCountryCode",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "localRecentHistoryItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUserRecentHistoryItem",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "checkoutUserId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasCheckoutUserId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "isAutomatedOfferNotificationDisabled",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "disableAutomatedOfferBellNotification"
    }
  ],
  "storageKey": "isEnabled(key:\"disableAutomatedOfferBellNotification\")"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": "showUnreadOnly"
  }
],
v4 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds"
},
v5 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v6 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVip",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "excludeItemPks",
    "variableName": "localRecentHistoryItemIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  }
],
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v13 = [
  (v12/*: any*/),
  (v2/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profileStatus",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "rewards",
  "storageKey": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentProgram",
      "storageKey": null,
      "args": null,
      "concreteType": "ParentProgram",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "programInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v2/*: any*/)
          ]
        }
      ]
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerDisplayable",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "preferences",
  "storageKey": null,
  "args": null,
  "concreteType": "UserPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "shareActivities",
      "args": null,
      "storageKey": null
    }
  ]
},
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "conversationSummary",
  "storageKey": null,
  "args": null,
  "concreteType": "Summary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "unread",
      "args": null,
      "storageKey": null
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "displayName",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v24 = [
  (v9/*: any*/),
  (v23/*: any*/)
],
v25 = [
  {
    "kind": "Literal",
    "name": "elementTypes",
    "value": [
      "PENDING_FEEDBACK",
      "TRADE_REWARD",
      "TRADE_REWARD_PRORATED",
      "TRADE_REWARD_PROGRAM",
      "AUTOMATED_OFFER"
    ]
  },
  (v5/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "eventDate",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": "thumbnail",
  "name": "firstPhotoWebPath",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v29 = {
  "kind": "Variable",
  "name": "rootId",
  "variableName": "previewKey"
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v31 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "path",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isLinkable",
    "args": null,
    "storageKey": null
  }
],
v32 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "linkData",
  "storageKey": null,
  "args": null,
  "concreteType": "LinkData",
  "plural": false,
  "selections": (v31/*: any*/)
},
v33 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "modules",
    "storageKey": null,
    "args": null,
    "concreteType": "NavigationModule",
    "plural": true,
    "selections": [
      (v30/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "NavigationTopLevel",
        "plural": true,
        "selections": [
          (v30/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "column",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "items",
            "storageKey": null,
            "args": null,
            "concreteType": "NavigationItem",
            "plural": true,
            "selections": [
              (v30/*: any*/),
              (v32/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v2/*: any*/)
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "imageLinkData",
        "storageKey": null,
        "args": null,
        "concreteType": "LinkData",
        "plural": false,
        "selections": (v31/*: any*/)
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitlePrimary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageTitleSecondary",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageHeight",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageWidth",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "imageLink",
        "args": null,
        "storageKey": null
      },
      (v32/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "isHighlighted",
        "args": null,
        "storageKey": null
      },
      (v12/*: any*/),
      (v2/*: any*/)
    ]
  },
  (v2/*: any*/)
],
v34 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "zipCode"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "headerRootQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Header_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "headerRootQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isNotificationsEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "NOTIFICATIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isCartEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "CART"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"CART\")"
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": "isSuggestionsFeatureEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEARCH_BAR_SUGGESTIONS"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEARCH_BAR_SUGGESTIONS\")"
          },
          (v2/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isClient",
            "selections": [
              {
                "kind": "ScalarField",
                "alias": "relayIsClient",
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "AccountNav_viewer$defer$AccountNavContent_viewer",
                "metadata": null,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "isMessageCenterEnabled",
                    "name": "isEnabledByLocale",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "featureName",
                        "value": "MESSAGE_CENTER"
                      }
                    ],
                    "storageKey": "isEnabledByLocale(featureName:\"MESSAGE_CENTER\")"
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_viewer$defer$ActivityFeed_viewer",
                "metadata": null,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": "promoCodeMessaging",
                    "name": "featureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "promoCodeMessaging"
                      }
                    ],
                    "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_initialViewer$defer$Conversations_viewer",
                "metadata": null,
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "conversations",
                        "storageKey": "conversations(filter:\"showUnreadOnly\")",
                        "args": (v3/*: any*/),
                        "concreteType": "ConversationConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "metadata",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConversationMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalUnreadConversationCount",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Notifications_initialViewer$defer$NotificationsIcon_viewer",
                "metadata": null,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "conversations",
                        "storageKey": "conversations(filter:\"showUnreadOnly\")",
                        "args": (v3/*: any*/),
                        "concreteType": "ConversationConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "metadata",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ConversationMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "lastUnreadMessageDate",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "if": null,
                "kind": "Defer",
                "label": "Header_viewer$defer$userTracking_viewer",
                "metadata": null,
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasCheckoutUserId",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "transactionsCounter",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "checkoutUserId"
                          }
                        ],
                        "concreteType": "TransactionsCounter",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": "guestCheckoutTransactions",
                            "name": "guest",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": "submittedTransactions",
                                "name": "submitted",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": "confirmedTransactions",
                                "name": "confirmed",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "CART"
                    ]
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "items",
                            "storageKey": "items(first:3)",
                            "args": [
                              (v5/*: any*/)
                            ],
                            "concreteType": "PortfolioItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "totalResults",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": [
                  (v6/*: any*/)
                ],
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "profile",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Profile",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "SearchBar_viewer$defer$getRecentHistory_user",
                    "metadata": null,
                    "selections": [
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "fetchUserRecentHistoryItem",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "recentHistoryItems",
                            "storageKey": null,
                            "args": (v10/*: any*/),
                            "concreteType": "RecentHistoryItemsConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "RecentHistoryItemsEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "contemporaryTrackingString",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "firstPhotoWebPath",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "size",
                                            "value": "small"
                                          }
                                        ],
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "pdpURL",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "browseUrl",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "categoryCode",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "categoryPath",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "seller",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Seller",
                                        "plural": false,
                                        "selections": (v13/*: any*/)
                                      },
                                      (v2/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "cursor",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pageInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "endCursor",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasNextPage",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "recentHistoryItems",
                            "args": (v10/*: any*/),
                            "handle": "connection",
                            "key": "getRecentHistory_recentHistoryItems",
                            "filters": [
                              "excludeItemPks"
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "if": null,
                    "kind": "Defer",
                    "label": "Header_viewer$defer$userTracking_user",
                    "metadata": null,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstSessionDate",
                        "args": null,
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "verifiedTradeStatus",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "authMetadata",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserExistsMetadataType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "emailOnly",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "hasPassword",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "profile",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Profile",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "zipCode",
                            "args": null,
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ]
                      },
                      (v12/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalMessagesToDealers",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v16/*: any*/),
                          (v18/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "mentionMeTagParameters",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "mentionMeTagParameters",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ciphertext",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "nonce",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "activePromotion",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Promotion",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "campaignName",
                            "args": null,
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "isClient",
                    "selections": [
                      (v20/*: any*/),
                      {
                        "kind": "Condition",
                        "passingValue": false,
                        "condition": "hasTradeUserId",
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "AccountNav_user$defer$AccountNavContent_user",
                            "metadata": null,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "profile",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Profile",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/)
                                ]
                              },
                              (v21/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "if": null,
                        "kind": "Defer",
                        "label": "AccountNav_user$defer$AccountNavTrigger_user",
                        "metadata": null,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "profile",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Profile",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "firstName",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v8/*: any*/),
                          {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasTradeUserId",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "tradeFirmRewards",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmRewards",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "currentYearPoints",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "currentProgram",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ParentProgram",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "programInfo",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "LoyaltyProgram",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          (v2/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "hasTradeUserId",
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "AccountNav_user$defer$TradeAccountNavContent_user",
                            "metadata": null,
                            "selections": [
                              (v12/*: any*/),
                              (v8/*: any*/),
                              (v21/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "tradeFirm",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TradeFirmType",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v16/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "publicProfile",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeFirmPublicProfileType",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "urlLabel",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "members",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "TradeFirmMemberType",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "userId",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "publicProfileManager",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v2/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "Condition",
                        "passingValue": true,
                        "condition": "isClient",
                        "selections": [
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$ShareActivityAlert_user",
                            "metadata": null,
                            "selections": [
                              (v12/*: any*/),
                              (v20/*: any*/)
                            ]
                          },
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$ActivityFeed_user",
                            "metadata": null,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "activePromotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "promotionMeta",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PromotionMeta",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "displayMessage",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "displayCta",
                                        "args": null,
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "adjustmentRateList",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": null,
                                    "plural": true,
                                    "selections": [
                                      (v14/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "reference",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v17/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "flatAdjustmentRate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FlatAdjustmentRate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "rate",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "FinancialAmount",
                                        "plural": false,
                                        "selections": (v24/*: any*/)
                                      },
                                      (v2/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "percentAdjustmentRate",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PercentAdjustmentRate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "rate",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v2/*: any*/)
                                    ]
                                  },
                                  (v2/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "activityFeed",
                                "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)",
                                "args": (v25/*: any*/),
                                "concreteType": "ActivityFeedConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ActivityFeedEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ActivityFeedElement",
                                        "plural": false,
                                        "selections": [
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v12/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "apiType",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "status",
                                            "args": null,
                                            "storageKey": null
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "anchors",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Anchor",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "sourceType",
                                                "args": null,
                                                "storageKey": null
                                              },
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "source",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": null,
                                                "plural": false,
                                                "selections": [
                                                  (v14/*: any*/),
                                                  (v2/*: any*/),
                                                  {
                                                    "kind": "InlineFragment",
                                                    "type": "TradeFirmReward",
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "rewardEarned",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "FinancialAmount",
                                                        "plural": false,
                                                        "selections": (v24/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "type": "ParentProgram",
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "programInfo",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "LoyaltyProgram",
                                                        "plural": false,
                                                        "selections": [
                                                          (v22/*: any*/),
                                                          (v17/*: any*/),
                                                          (v2/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "type": "OrderFeedback",
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "alias": null,
                                                        "name": "token",
                                                        "args": null,
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "transaction",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Transaction",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "item",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v28/*: any*/),
                                                              (v2/*: any*/)
                                                            ]
                                                          },
                                                          (v2/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "type": "Transaction",
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "summary",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "TransactionSummaryObject",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "offerDiscountPercentage",
                                                            "args": null,
                                                            "storageKey": null
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "item",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Item",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "localizedPdpUrl",
                                                            "args": null,
                                                            "storageKey": null
                                                          },
                                                          (v11/*: any*/),
                                                          (v28/*: any*/),
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "pricing",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ItemPricing",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "retailPrice",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "FinancialAmount",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "convertedAmountList",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ConvertedAmountList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                      (v23/*: any*/),
                                                                      (v9/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          },
                                                          (v2/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "mostRecentOffer",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Offer",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "amountPerItem",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "FinancialAmount",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "convertedAmountList",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "ConvertedAmountList",
                                                                "plural": true,
                                                                "selections": (v24/*: any*/)
                                                              }
                                                            ]
                                                          },
                                                          (v2/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v2/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "if": null,
                            "kind": "Defer",
                            "label": "Notifications_user$defer$NotificationsIcon_user",
                            "metadata": null,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "activePromotion",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "plural": false,
                                "selections": (v13/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "activityFeed",
                                "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)",
                                "args": (v25/*: any*/),
                                "concreteType": "ActivityFeedConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ActivityFeedEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ActivityFeedElement",
                                        "plural": false,
                                        "selections": [
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v2/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": false,
            "condition": "hasSessionCountryCode",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "regInfo",
                "name": "regionalInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "countryCode",
                    "args": null,
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v29/*: any*/)
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v33/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchTradeNav",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "tradeNavigation",
                "name": "navigation",
                "storageKey": null,
                "args": [
                  (v29/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "userType",
                    "value": "TRADE"
                  }
                ],
                "concreteType": "Navigation",
                "plural": false,
                "selections": (v33/*: any*/)
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasTradeUserId",
            "selections": [
              {
                "if": null,
                "kind": "Defer",
                "label": "Contact1stdibsLink_viewer$defer$TradeRepCircle_viewer",
                "metadata": null,
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "hasUserId",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": "tradeRep",
                        "name": "userRelationships",
                        "storageKey": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "relationshipType",
                            "value": "TRADE"
                          },
                          (v4/*: any*/)
                        ],
                        "concreteType": "UserRelationship",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": "userDataB",
                            "name": "userDataBRep",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "RepData",
                            "plural": true,
                            "selections": [
                              (v22/*: any*/),
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "photoUrl",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchRegionalInfo",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "regionalInfo",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v6/*: any*/),
                  (v34/*: any*/)
                ],
                "concreteType": "RegionalInfo",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "incomeLevel",
                    "storageKey": null,
                    "args": [
                      (v34/*: any*/)
                    ],
                    "concreteType": "IncomeLevel",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomeBracket",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "incomePercentile",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v9/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "headerRootQuery",
    "id": "ferrum/289.0.0-2020-11-03T20:56:25.991Z/headerRootQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'b8bdc329d7fe7f33e22f6c84af05cc76';
export default node;
